module.exports = __webpack_public_path__ + "img/2.bfbf6020.png";